export default __webpack_public_path__ + "static/media/solution_81.fb33b7fe.png";